import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
        //   click: {
        //     header: 'toggleSection',
        //   }
            change: {
                change: 'refresh',
            }
        }

        this.ajaxurl = '/wp/wp-admin/admin-ajax.php';
    }

    init() {
        setTimeout(() => {
            let form = $('#filtresForm');
            let $this = this;

            $(function(){
                var keyStop = {
                    8: ":not(input:text, textarea, input:file, input:password)", // stop backspace = back
                    13: "input:text, input:password", // stop enter = submit 
                    end: null
                };
                $(form).bind("keydown", function(event){
                    var selector = keyStop[event.which];

                    if(selector !== undefined && $(event.target).is(selector)) {
                        $this.refresh();
                        event.preventDefault(); //stop event
                    }
                    return true;
                });
            });

            jQuery('.b-relation_listing').on(
                'click',
                'article.c-card',
                function () {
                    $this.call('openPopup', {id: jQuery(this).data('id'), nom: jQuery(this).data('nom')}, 'Map');
                }
            );
              
            jQuery.ajax({
                url: this.ajaxurl,
                type: 'POST',
                data: form.serialize(),
                success: function( response ){
                    if($('.b-relation_listing').length) {
                        $('.b-relation_listing').html(response.content);
                    }

                    if ($('.b-relation_pagination').length) {
                        $('.b-relation_pagination').html(response.pagination);
                    }

                    if($('.b-relation_number').length && response.count) {
                        $('.b-relation_number').html(response.count);
                    }

                    
                    $this.call('removeCustomMarker', false, 'Map');
                    if (response.lat && response.lng) {
                        $this.call('initMarkerAdresse', {lat: lat, lng: lng}, 'Map');
                    }
                    
                    $this.call('updateMap', response.posts_map, 'Map');
                },
            });
              
              setTimeout(() => {
                  this.call('update', false, 'Scroll'); // update Locomotive Scroll
              }, 500);
        }, 500);
    }

    refresh() {
        let form = $('#filtresForm');
        let $this = this;
        
        jQuery.ajax({
            url: this.ajaxurl,
            type: 'POST',
            data: form.serialize(),
            success: function( response ){
                if($('.b-relation_listing').length) {
                    $('.b-relation_listing').html(response.content);
                }

                if ($('.b-relation_pagination').length) {
                    $('.b-relation_pagination').html(response.pagination);
                }

                if($('.b-relation_number').length && response.count) {
                    $('.b-relation_number').html(response.count);
                }
                
                $this.call('removeCustomMarker', false, 'Map');
                if (response.lat && response.lng) {
                    $this.call('initMarkerAdresse', {lat: response.lat, lng: response.lng}, 'Map');
                }

                $this.call('updateMap', response.posts_map, 'Map');
            },
        });
        
        setTimeout(() => {
            this.call('update', false, 'Scroll'); // update Locomotive Scroll
        }, 500);
    }
}
